import { getFirstLetterOfString } from "utils/common";

export const formatters = {
    "first-letter-uppercase": getFirstLetterOfString
}